const CURRENCY_USD: string = 'usd';

export default CURRENCY_USD;
